import { NgModule } from '@angular/core';
import { TimelineModule } from 'primeng/timeline';
import { ImageModule } from 'primeng/image';
import { OverlayPanelModule } from 'primeng/overlaypanel';

const modules = [TimelineModule, ImageModule, OverlayPanelModule];

@NgModule({
	imports: modules,
	exports: modules,
})
export class PrimengModule {
	constructor() {}
}
